<template>
    <v-footer
        dark
        padless
    >
        <v-container>
            <v-row class="mt-5">
                <v-col
                    cols="12"
                    sm="6"
                    md="4"
                    lg="3"
                >
                    <div class="d-flex align-center">
                        <v-img
                            class="mr-2"
                            src="../assets/White Logo.png"
                            max-width="50"
                            max-height="50"
                            alt="Come Connect Logo"
                        />
                        <div class="title">
                            Come Connect
                        </div>
                    </div>
                    <div class="mt-3">
                        <v-icon class="mx-2">
                            email
                        </v-icon>
                        <a href="mailto:hello@comeconnect.me">hello@comeconnect.me</a>
                    </div>
                </v-col>
                <v-col cols="12" class="d-sm-none">
                    <v-divider />
                </v-col>
                <v-col
                    cols="12"
                    sm=""
                    md="3"
                >
                    <span class="title">Quick Links</span><br>
                    <ul class="footer-list">
                        <li
                            v-for="link in quickLinks"
                            :key="link.text"
                        >
                            <router-link
                                :to="link.route"
                            >
                                {{ link.text }}
                            </router-link>
                        </li>
                    </ul>
                </v-col>
                <v-col
                    cols="12"
                    class="d-sm-none"
                >
                    <v-divider />
                </v-col>
                <v-col
                    cols="12"
                    md="5"
                    lg="6"
                >
                    <span class="title">Credits</span><br>
                    <ul class="footer-list">
                        <li>
                            Illustrations -
                            <a href="https://twitter.com/ninalimpi" title="Nina Limpi">
                                Nina Limpi
                            </a>
                            at
                            <a href="https://undraw.co/" title="Undraw" target="_blank">
                                undraw.co
                            </a>
                        </li>
                        <li>
                            Icons -
                            <a href="https://www.flaticon.com/authors/freepik" title="Freepik">
                                Freepik
                            </a>
                            from
                            <a href="https://www.flaticon.com/" title="Flaticon" target="_blank">
                                flaticon.com
                            </a>
                            is licensed by
                            <a href="http://creativecommons.org/licenses/by/3.0/" title="Creative Commons BY 3.0" target="_blank">
                                CC 3.0
                            </a>
                        </li>
                    </ul>
                </v-col>
                <v-col cols="12">
                    <div class="text-center my-3">
                        Copyright
                        <v-icon size="22">
                            copyright
                        </v-icon>
                        {{ new Date().getFullYear() }} All rights reserved - <strong>Come Connect</strong>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </v-footer>
</template>

<script>
const quickLinks = [
    {
        text: 'Homepage',
        route: {
            name: 'home'
        }
    },
    {
        text: 'Contact Us',
        route: {
            name: 'contactUs'
        }
    },
    {
        text: 'Sign Up',
        route: {
            name: 'signUp'
        }
    },
    {
        text: 'Login',
        route: {
            name: 'login'
        }
    },
    {
        text: 'Forgot Password',
        route: {
            name: 'forgotPassword'
        }
    },
    {
        text: 'Terms and Conditions',
        route: {
            name: 'termsAndConditions'
        }
    },
    {
        text: 'Privacy Policy',
        route: {
            name: 'privacyPolicy'
        }
    }
]

export default {
    name: 'Footer',
    data () {
        return {
            quickLinks
        }
    }
}
</script>

<style lang="scss" scoped>
.footer-list {
    list-style-type: none;
    padding: 0;
}
</style>
